<template>
  <div>
    <pc v-if="isPc"></pc>
    <mobile v-else></mobile>
  </div>
</template>

<script>
import pc from './pc.vue';
import mobile from './mobile.vue';
export default {
  name: "FenceIndex",
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  watch: {
  },
  computed: {
    isPc(){
      return this.$store.state.clientWidth > 768
    },
  },
  components: {
    pc,
    mobile
  },
};
</script>

<style lang="scss" scoped>
</style>
